import { Component, OnInit } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";
declare var jQuery: any;
declare var $: any;

@Component({
  selector: 'app-indiafixture',
  templateUrl: './indiafixture.component.html',
  styleUrls: ['./indiafixture.component.scss']
})
export class IndiafixtureComponent implements OnInit {

  constructor(private allpagesService: AllPageService,) { }

  seasontypeList: any = "";
  fixturetypeList: any = "";
  fixtureRequest: any = {};
  selectedsize: any = 1;
  bannerrequest: any = {};
  bannerList: any = "";


  ngOnInit() {
    this.loadBanner();
    this.loadcommercialfixturetype();
    this.allpagesService.getSeasontype().then((data) => {
      this.seasontypeList = data;

      setTimeout(() => {
        jQuery(".fixtures-name").click(function () {
          if (jQuery(this).hasClass('ok')) {
            // do nothing
          } else {
            var tabid = jQuery(this).attr('id');
            console.log(tabid);
            jQuery(".fixtures-name").removeClass('ok');
            jQuery(this).addClass('ok');
            jQuery(".fixtures-main-content").removeClass('ok');
            jQuery("#" + tabid + "-content").addClass("ok");
          }
          return false;
        });
      }, 1000);

    });

    jQuery(".fixtures-name").click(function () {
      if (jQuery(this).hasClass('active')) {
        // do nothing
      } else {
        var tabid = jQuery(this).attr('id');
        jQuery(".fixtures-name").removeClass('active');
        jQuery(this).addClass('active');
        jQuery(".fixtures-main-content").removeClass('active');
        jQuery("#" + tabid + "-content").addClass("active");
      }
      return false;
    });
    jQuery(".fixture-season-detail a.season-top").click(function () {
      jQuery(".fixture-season-detail").toggleClass("open");
      return false;
    });
    jQuery(".fixture-season-detail ul.fixture-season-list li ").click(function () {
      jQuery(".fixture-season-detail").removeClass("open");
      return false;
    });
  }

  loadBanner() {
    this.bannerrequest = {
      title: "India Fixture"
    };
    let request = Object.assign({}, this.bannerrequest);
    this.allpagesService.getBannerList(request).then((data: any) => {
      this.bannerList = data.data[0];
      //console.log(this.bannerList);
    });
  }

  tabaction() {
    this.selectedsize = jQuery("#select_tab").val();
    //console.warn(this.selectedsize);
    this.loadcommercialfixturetype();
  }

  loadcommercialfixturetype() {
    this.fixtureRequest = {
      season_type_id: this.selectedsize
    }
    let request = Object.assign({}, this.fixtureRequest);
    this.allpagesService.getCommercialFixture(request).then((data: any) => {
      this.fixturetypeList = data;
      //console.warn(this.fixturetypeList);
      setTimeout(() => {
        jQuery(".courses-name").click(function () {
          if (jQuery(this).hasClass('active')) {
            // do nothing
          } else {
            var tabid = jQuery(this).attr('id');
            jQuery(".courses-name").removeClass('active');
            jQuery(this).addClass('active');
            jQuery(".course-main-content").removeClass('active');
            jQuery("#" + tabid + "-content").addClass("active");
          }
          return false;
        });
      }, 1000);
    });
  }

}
